import { render } from "./EventPresale.vue?vue&type=template&id=172bfc46"
import script from "./EventPresale.vue?vue&type=script&lang=js"
export * from "./EventPresale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__